import * as v from "valibot";

import { rpcContract } from "../rpc";

export const deleteWorldRpcContract = rpcContract({
  name: "deleteWorld",
  paramsSchema: v.object({
    worldId: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type DeleteWorldParams = v.InferOutput<(typeof deleteWorldRpcContract)["paramsSchema"]>;
export type DeleteWorldResult = v.InferOutput<(typeof deleteWorldRpcContract)["resultSchema"]>;
